<template>
  <div class="main-title">
    <div class="main-title-top">
      <slot name="top"></slot>
    </div>
    <p class="title">{{title}}</p>
    <slot name="bottom"></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss" scoped>
.main-title {
  padding: 0.36rem 0.32rem;
  .title {
    font-size: 0.38rem;
    color: #1f2933;
    font-weight: 500;
    text-align: left;
    line-height: 0.48rem;
  }
}
</style>

